import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Pagewrapper } from "../../components";
import Row from "react-bootstrap/Row";

const Sobre = (props) => (
  <Pagewrapper {...props}>
    <Container>
      <Row>
        <Col>
          <h1 className="mt-5 text-center">A Nova Plataforma de Pesquisa Jurídica da LEX Editora</h1>
        </Col>
      </Row>
          <p> </p>
    
          <p>A nova plataforma de pesquisa jurídica da LEX Editora representa a evolução natural de uma história construída com rigor, tradição e compromisso com o conhecimento. Unimos excelência editorial e tecnologia de ponta para oferecer uma experiência de pesquisa mais rápida, inteligente e confiável. Projetada para quem vive o Direito com seriedade.</p>
          
          <p>Nossa equipe de especialistas monitora, em tempo real, jurisprudência e legislação, assegurando atualizações constantes, precisas e verificadas. Essa agilidade garante que você trabalhe sempre com a informação mais atual e segura do mercado jurídico.</p>
          
          <p>Já a doutrina, fundamento da herança editorial da LEX Editora, é construída por autores que exercem a coragem intelectual de interpretar e escrever o Direito. Acreditamos na força das ideias, na precisão da linguagem e no valor de quem se dedica a produzir conhecimento jurídico de alta qualidade. Nosso compromisso é editar, organizar e entregar esse conteúdo com rigor técnico, clareza e absoluta confiabilidade.</p>
          
          <p>O resultado é uma plataforma que integra tradição e inovação, unindo profundidade de conteúdo, inteligência tecnológica e a credibilidade que marcou gerações de profissionais do Direito.</p>
          
          <p><strong>LEX Editora</strong> - onde história e tradição se unem para formar um legado capaz de orientar gerações e moldar o futuro do conhecimento jurídico.</p>

    </Container>
  </Pagewrapper>
);

export default Sobre;
